import React, { Component } from 'react';
import { Alert as AlertB } from 'react-bootstrap';

class Alert extends Component {
	render() {
		let { stateSetter, showAlert, alertMessage } = this.props;

		return (
			<AlertB
				bsStyle="danger"
				onDismiss={() =>
					stateSetter([
						{ state: 'showAlert', value: false },
						{ state: 'alertMessage', value: '' },
					])
				}
				style={{ display: showAlert ? '' : 'none' }}
			>
				{alertMessage}
			</AlertB>
		);
	}
}

export default Alert;



// WEBPACK FOOTER //
// ./components/UserSetup/Alert.js